import { Role } from "@/v2/types";
import ArFormCombobox from "../form/ComboBoxFormField";
import { FieldValues, Path } from "react-hook-form";
import FindAllRoles from "@/v2/api/users/FindAllRoles";

export function RolesComboBox<T extends FieldValues>({
    name,
    storeFullObject = false,
    setSelected,
    defaultValue,
}: {
    name: Path<T>;
    storeFullObject?: boolean;
    setSelected?: (value: Role | null) => void;
    defaultValue: Role | null;
}) {
    return (
        <ArFormCombobox<T, Role>
            defaultValue={defaultValue}
            name={name}
            label="Select Role"
            queryKey="roles"
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllRoles({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(role) => role.name}
            renderItem={(role) => (
                <div className="flex flex-col">
                    <span>{role.name}</span>
                </div>
            )}
            placeholder="Select role..."
            width="w-full"
            storeFullObject={storeFullObject}
            onItemSelect={(role: Role | null) => {
                setSelected && setSelected(role);
            }}
        />
    );
}
